import { ignoreObjectProps } from '@paymash/logger-capacitor';

export const ignoreImageProps = (data: Object): Object => {
  return ignoreObjectProps(data, ['images', 'image']);
};
